<ion-content>
  <!-- <div class="container modal fade" [style.display]="showAddPopup? 'block' : 'none'">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="d-flex pt-10 pb-10 pr-10 pl-0">
          <img src="././assets/icon/backArrow.svg" class="cp" (click)="backBtn()"><label
            class="font_semibold fs-18 fs_16ForMobile ml-10 mt-5 black_color">Profile / {{isEditModeactive?'Edit':'Setup'}}</label>
        </div>
      </div>
      <div class="modal-body">
        <form [formGroup]="companyInformationForm">
          <div class="cardBox">
            <ion-row>
              <ion-col size-sm="5" size-md="5" size-lg="5" size-xs="5" class="mt-10">
                <ion-row class="upload-box">
                  <ion-col size-sm="4" size-md="4" size-lg="4" size-xs="4">
                    <img *ngIf="uploadedFileUrl!=''" [src]="uploadedFileUrl" class="cp componyLogo"
                      (click)="showImg(uploadedFileUrl,'Compony Logo')">
                  </ion-col>
                  <ion-col size-sm="8" size-md="8" size-lg="8" size-xs="8">
                    <div class="mt-20">
                      <label class="text-blue text_right font_regular cp" (click)="browseImage.click()"><u>Upload
                          Logo</u></label>
                      <input #browseImage type="file" (change)="uploadImage($event)" style="display:none;">
                    </div>
                  </ion-col>
                </ion-row>
                <label class="red-cl font_regular fs-12" *ngIf="formSubmitted && companyInformationForm.controls['logo'].hasError('required')">
                  Logo is required</label>
              </ion-col>
              <ion-col size-sm="5" size-md="5" size-lg="5" size-xs="5" class="mt-10">
                <div class="formLabelRegularfs14 mb-5">Custom Color Theme</div>
                <div class="d-flex">
                  <label class="rounded-color-picker"
                    [style.background-color]="companyInformationForm.value.moduleNameColor"></label>
                  <label class="rounded-color-picker"
                    [style.background-color]="companyInformationForm.value.subModuleButtonColor"></label>
                  <label class="rounded-color-picker"
                    [style.background-color]="companyInformationForm.value.buttonColorName"></label>
                  <label *ngFor="let item of dashboardColorNameList" class="rounded-color-picker"
                    [style.background-color]="item"></label>
                  <label class="plusIcon cp" (click)="onClickColorPalletPlushIcon()">+</label>
                </div>
              </ion-col>
              <ion-col size-sm="5" size-md="5" size-lg="5" size-xs="5" class="mt-10">
                <div class="formLabelRegularfs14 mb-5">Company Name<span class="red-cl">&nbsp;*</span></div>
                <mat-form-field class="w-100 mat-height40 mat-input-style">
                  <input matInput formControlName="companyName" placeholder="Company Name" class="font_regular">
                  <mat-error *ngIf="companyInformationForm.controls['companyName'].hasError('required')">Company Name
                    is required</mat-error>
                </mat-form-field>
              </ion-col>
              <ion-col size-sm="5" size-md="5" size-lg="5" size-xs="5" class="mt-10">
                <div class="formLabelRegularfs14 mb-5">Fiscal Year<span class="red-cl">&nbsp;*</span></div>
                <mat-form-field class="w-100 mat-height40 mat-input-style">
                  <mat-select placeholder="Select" formControlName="fiscalYear">
                    <mat-option [value]="'Jan_Dec'">Jan-Dec</mat-option>
                    <mat-option [value]="'Apr_Mar'">Apr-Mar</mat-option>
                    <mat-option [value]="'July_Jun'">July-Jun</mat-option>
                    <mat-option [value]="'Oct_Sep'">Oct-Sep</mat-option>
                  </mat-select>
                  <mat-error *ngIf="companyInformationForm.controls['fiscalYear'].hasError('required')">Fiscal Year is
                    required</mat-error>
                </mat-form-field>
              </ion-col>
              <ion-col size-sm="5" size-md="5" size-lg="5" size-xs="5" class="mt-10">
                <div class="formLabelRegularfs14 mb-5">First Name of HR Admin<span class="red-cl">&nbsp;*</span></div>
                <mat-form-field class="w-100 mat-height40 mat-input-style">
                  <input matInput formControlName="firstnameOfHrAdmin" placeholder="First Name of HR Admin" class="font_regular">
                  <mat-error *ngIf="companyInformationForm.controls['firstnameOfHrAdmin'].hasError('required')">Name of HR
                    Admin is required</mat-error>
                </mat-form-field>
              </ion-col>
                            <ion-col size-sm="5" size-md="5" size-lg="5" size-xs="5" class="mt-10">
                <div class="formLabelRegularfs14 mb-5">Last Name of HR Admin<span class="red-cl">&nbsp;*</span></div>
                <mat-form-field class="w-100 mat-height40 mat-input-style">
                  <input matInput formControlName="lastnameOfHrAdmin" placeholder="Last Name of HR Admin" class="font_regular">
                  <mat-error *ngIf="companyInformationForm.controls['lastnameOfHrAdmin'].hasError('required')">Name of HR
                    Admin is required</mat-error>
                </mat-form-field>
              </ion-col>
              <ion-col size-sm="5" size-md="5" size-lg="5" size-xs="5" class="mt-10">
                <div class="formLabelRegularfs14 mb-5">Email of HR Admin<span class="red-cl">&nbsp;*</span></div>
                <mat-form-field class="w-100 mat-height40 mat-input-style">
                  <input matInput formControlName="emailOfHrAdmin" placeholder="Email of HR Admin"
                    class="font_regular">
                  <mat-error *ngIf="companyInformationForm.controls['emailOfHrAdmin'].hasError('required')">Email of
                    HR Admin is required</mat-error>
                </mat-form-field>
              </ion-col>
              <ion-col size-sm="5" size-md="5" size-lg="5" size-xs="5" class="mt-10">
                <div class="formLabelRegularfs14 mb-5">Contact Number<span class="red-cl">&nbsp;*</span></div>
                <mat-form-field class="w-100 mat-height40 mat-input-style">
                  <input matInput formControlName="contactNo" placeholder="Contact Number" class="font_regular">
                  <mat-error *ngIf="companyInformationForm.controls['contactNo'].hasError('required')">Contact Number
                    is required</mat-error>
                </mat-form-field>
              </ion-col>
            </ion-row>
          </div>
          <div class="mt-10 text-right">
            <button type="button" class="catalystOrangeBgColor add_btn ml-10" (click)="updateProfile()">Update</button>
          </div>
          <div class="clear50"></div>
        </form>
      </div>
    </div>
  </div> -->
  <div class="container modal fade" [style.display]="showDetailsPopup? 'block' : 'none'">
    <div class="modal-dialog">
      <div class="modal-content">
        <ion-row>
          <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12">
            <div class="d-flex pt-10 pb-10 pr-10 pl-0">
              <img src="././assets/icon/backArrow.svg" class="cp" (click)="backBtn()" />
              <label class="font_semibold fs-18 fs_16ForMobile ml-10 mt-5 black_color ">Profile Management</label>
            </div>
          </ion-col>
          <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6" class="text-right">
            <!-- <div class="d-inline-flex pt-10 pb-10 pr-10 pl-0 ">
              <img src="././assets/icon/editIconOrange.svg" (click)="editCompany()" class="ml-10 cp">
            </div> -->
          </ion-col>
        </ion-row>
      </div>
      <div class="modal-body">
        <div class="detailsCardBox">
          <div class="headingOfShowBox">
            <ion-row class="p-0">
              <ion-col size-sm="12" size-md="6" size-lg="6" size-xs="12" class="p-0">
                <div class="font_semibold fs-16 fs_14ForMobile ">Entered Preliminary Information</div>
              </ion-col>
            </ion-row>
          </div>
          <div class="p-10" *ngFor="let item of companyData">
            <ion-row class="mb-10">
              <ion-col size-sm="12" size-md="6" size-lg="4" size-xs="12">
                <div class="d-flex" *ngIf="!editLogoFlag">
                  <img *ngIf="item.logo" [src]="fileUploadPath+item.logo" class="cp componyLogo responsive-logo-size" (click)="showImg(item.logo,'Compony Logo')" />
                  <label *ngIf="!editLogoFlag" class="cp" (click)="editLogo()">
                    <img class="mr-5 cp imgdelete" title="Edit" src="././assets/icon/edit.png" />
                  </label>
                </div>
                <div class="mt-20" *ngIf="editLogoFlag">
                  <label class="text-blue text_right font_regular cp" (click)="browseImage.click()"><u>Upload Logo</u></label>
                  <img title="Cancel" (click)="canelEditLogo()" class="ml-10 imgdelete cp" src="././assets/icon/close_icon.png" />
                  <input #browseImage accept=".png, .jpeg, .jpg,.PNG, .JPEG, .JPG" type="file" (change)="uploadImage($event)" style="display:none;" />
                  <div class="font_italic fs-12 fs_12ForMobile gray_color">The logo must be less than 2 MB (png, jpg, jpeg, svg). The height should be at least 65px; Ideal logo size is 265px * 65px.</div>
                </div>
              </ion-col>
              <ion-col size="12" size-md="6" size-lg="4">
                <div class="formLabelRegularfs14">Company Name</div>
                <div class="formLabelBoldfs14">{{item.companyName}}</div>
              </ion-col>
              <ion-col size="12" size-md="6" size-lg="4">
                <div class="formLabelRegularfs14">Fiscal Year</div>
                <div class="formLabelBoldfs14">{{transform(item.fiscalYear)}}</div>
              </ion-col>
              <ion-col size-sm="12" size-md="6" size-lg="4" size-xs="12">
                <div class="formLabelRegularfs14">Custom Color Theme</div>
                <div class="d-flex">
                  <label class="rounded-color-picker firstColorofPicker" [style.background-color]="item.moduleNameColor"></label>
                  <label class="rounded-color-picker" [style.background-color]="item.subModuleButtonColor"></label>
                  <label class="rounded-color-picker" [style.background-color]="item.buttonColorName"></label>
                  <label *ngFor="let data of item.dashboardColorName;let isLast=last" [ngClass]="{'lastColorofPicker': isLast}" class="rounded-color-picker" [style.background-color]="data"></label>
                  <label class="cp" (click)="editCustomColor()">
                    <img class="ml-5 cp imgdelete" title="Edit" src="././assets/icon/edit.png" />
                  </label>
                  <!-- <label *ngIf="editCustomColorFlag" class="plusIcon cp" (click)="onClickColorPalletPlushIcon()">+</label> -->
                </div>
              </ion-col>
              <ion-col size-sm="12" size-md="6" size-lg="4" size-xs="12">
                <div class="formLabelRegularfs14">Start Date</div>
                <div class="formLabelBoldfs14">{{item.startDate | date:'dd-MM-yyyy'}}</div>
              </ion-col>
              <ion-col size-sm="12" size-md="6" size-lg="4" size-xs="12">
                <div class="formLabelRegularfs14">System Lock Date</div>
                <div class="formLabelBoldfs14">{{item.systemLockDate | date:'dd-MM-yyyy'}}</div>
              </ion-col>
              <!-- <ion-col size-sm="12" size-md="6" size-lg="4" size-xs="12">
                <div class="formLabelRegularfs14">No. of Licenses</div>
                <div class="formLabelBoldfs14">{{item.noOfLicenses}}</div>
              </ion-col> -->
              <ion-col size-sm="12" size-md="6" size-lg="4" size-xs="12">
                <div class="formLabelRegularfs14">Industry</div>
                <div class="formLabelBoldfs14">{{item.industry?.industryName}}</div>
              </ion-col>
              <ion-col size-sm="12" size-md="6" size-lg="4" size-xs="12">
                <div class="formLabelRegularfs14">Sub Industries</div>
                <label class="formLabelBoldfs14" *ngFor="let data of item.subindustry;let isLast=last">{{data.subIndustryName}}{{isLast ? '' : ', '}}</label>
              </ion-col>
              <ion-col size-sm="12" size-md="6" size-lg="4" size-xs="12">
                <div class="formLabelRegularfs14">Status</div>
                <div class="formLabelBoldfs14">{{transform(item.status)}}</div>
              </ion-col>
            </ion-row>
          </div>
        </div>
        <div class="detailsCardBox">
          <div class="headingOfShowBox">
            <ion-row class="p-0">
              <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6" class="p-0">
                <div class="font_semibold fs-16 fs_14ForMobile ">Nominated HR Admin</div>
              </ion-col>
            </ion-row>
          </div>
          <div class="p-10" *ngFor="let item of companyData">
            <ion-row class="mb-10">
              <ion-col size-sm="12" size-md="6" size-lg="4" size-xs="12">
                <div class="formLabelRegularfs14">Name of HR Admin</div>
                <div class="formLabelBoldfs14">{{item.firstnameOfHrAdmin}} {{item.lastnameOfHrAdmin}}</div>
              </ion-col>
              <ion-col size-sm="12" size-md="6" size-lg="4" size-xs="12">
                <div class="formLabelRegularfs14">Email of HR Admin</div>
                <div class="formLabelBoldfs14">{{item.emailOfHrAdmin}}</div>
              </ion-col>
              <ion-col size-sm="12" size-md="6" size-lg="4" size-xs="12">
                <div class="formLabelRegularfs14">Contact Number</div>
                <div class="formLabelBoldfs14">
                  {{item.contactNo}}&nbsp;
                  <label *ngIf="!editContactFlag" class="cp" (click)="editContact()">
                    <img class="mr-5 cp imgdelete" title="Edit" src="././assets/icon/edit.png" />
                  </label>
                </div>
                <div *ngIf="editContactFlag">
                  <form [formGroup]="companyInformationForm">
                    <ion-row>
                      <ion-col size-sm="10" size-md="10" size-lg="10" size-xs="10" class="mt-10">
                        <mat-form-field class="w-100 mat-height40 mat-input-style">
                          <input matInput type="number" formControlName="contactNo" placeholder="Type number here" class="font_regular" (blur)="updateProfile()" />
                          <mat-error *ngIf="companyInformationForm.controls['contactNo'].hasError('required')">Contact Number is required</mat-error>
                          <mat-error *ngIf="companyInformationForm.controls['contactNo'].hasError('pattern')">Please Enter Correct Contact Number</mat-error>
                        </mat-form-field>
                      </ion-col>
                    </ion-row>
                  </form>
                </div>
              </ion-col>
              <ion-col size="12">
                <div class="formLabelRegularfs14">Employee ID of MD/CEO</div>
                <div class="formLabelBoldfs14">{{item.employeeIdOfMD}}</div>
              </ion-col>
              <ion-col size="12" class="mt-10">
                <button type="button" class="catalystOrangeBgColor add_btn" (click)="showMultiHrAdmins(ViewMultipleHrAdmins)">View Multiple Hr's</button>

                <ng-template #ViewMultipleHrAdmins>
                  <div class="text-right">
                    <button matButton mat-dialog-close class="dialog_btns close_btn">
                      <ion-icon name="close-outline"></ion-icon>
                    </button>
                  </div>
                  <mat-dialog-content>
                    <div class="table-container">
                      <table class="table">
                        <thead class="table-header">
                          <tr>
                            <th>First</th>
                            <th>Last</th>
                            <th>Email</th>
                            <th>Number</th>
                          </tr>
                        </thead>
                        <tbody class="table-body" *ngIf="getMultipleHrAdmins.length > 0">
                          <tr *ngFor="let hrAdmin of getMultipleHrAdmins; let i=index">
                            <td>{{ hrAdmin.firstnameOfHrAdmin }}</td>
                            <td>{{ hrAdmin.lastnameOfHrAdmin }}</td>
                            <td>{{ hrAdmin.emailOfHrAdmin }}</td>
                            <td>{{ hrAdmin.contactNo }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </mat-dialog-content>
                </ng-template>
              </ion-col>
            </ion-row>
          </div>
        </div>
        <div class="detailsCardBox">
          <div class="headingOfShowBox">
            <ion-row class="p-0">
              <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6" class="p-0">
                <div class="font_semibold fs-16 fs_14ForMobile ">Module Access</div>
              </ion-col>
            </ion-row>
          </div>
          <div class="p-10">
            <ion-row class="mb-10">
              <ion-col size-sm="6" size-md="4" size-lg="3" size-xs="6" class="" *ngFor="let item of modulesOfHRAdmin;let isLast=last">
                <div class="tabsCard" [ngClass]="{'op05': !item.isAccessGiven}">
                  <ion-row class="center-content">
                    <ion-col size-sm="2" size-md="2" size-lg="2" size-xs="2">
                      <img class="h24" src="{{item.iconLink}}" />
                    </ion-col>
                    <ion-col size-sm="8" size-md="8" size-lg="8" size-xs="8">
                      <label class="formLabelBoldfs14">{{item.moduleName}}</label>
                    </ion-col>
                    <ion-col size-sm="2" size-md="2" size-lg="2" size-xs="2">
                      <img class="h24" *ngIf="item.isAccessGiven" src="././assets/icon/successGreencheckMarkIcon.svg" />
                    </ion-col>
                  </ion-row>
                </div>
              </ion-col>
            </ion-row>
          </div>
        </div>
        <div class="detailsCardBox">
          <div class="headingOfShowBox">
            <ion-row class="p-0">
              <ion-col size-sm="6" size-md="6" size-lg="6" size-xs="6" class="p-0">
                <div class="font_semibold fs-16 fs_14ForMobile">{{compStatus}}</div>
              </ion-col>
            </ion-row>
          </div>
          <div class="p-10" *ngFor="let item of companyData">
            <ion-row class="mb-10">
              <!-- <ion-col size-sm="12" size-md="6" size-lg="12" size-xs="12">
                <div class="formLabelBoldfs14">No. of Licenses : {{item.noOfLicenses}}</div>
              </ion-col> -->
              <ion-col size-sm="12" size-md="6" size-lg="4" size-xs="12">
                <div class="formLabelRegularfs14">
                  Upload Contract
                  <span class="red-cl">&nbsp;*</span>
                </div>
                <div class="formLabelBoldfs14">
                  <span *ngIf="item.uploadingTheContract"><a class="cp" [href]="item.uploadingTheContract" target="_blank">Contract</a></span>
                  <span *ngIf="!item.uploadingTheContract">-</span>
                </div>
              </ion-col>
              <ion-col size-sm="12" size-md="6" size-lg="4" size-xs="12">
                <div class="formLabelRegularfs14">
                  One-Time payment
                  <span class="red-cl">&nbsp;*</span>
                </div>
                <div class="formLabelBoldfs14">&#8377;&nbsp;{{item.enteringOneTimePaymentAmount? item.enteringOneTimePaymentAmount: '-'}}</div>
              </ion-col>
              <ion-col size-sm="12" size-md="6" size-lg="4" size-xs="12">
                <div class="formLabelRegularfs14">
                  AMC
                  <span class="red-cl">&nbsp;*</span>
                </div>
                <div class="formLabelBoldfs14">&#8377;&nbsp;{{item.enteringAMCcost? item.enteringAMCcost: '-'}}</div>
              </ion-col>
              <ion-col size-sm="12" size-md="6" size-lg="4" size-xs="12" class="mt-10">
                <div class="formLabelRegularfs14">
                  % Annual Increase
                  <span class="red-cl">&nbsp;*</span>
                </div>
                <div class="formLabelBoldfs14">{{item.enteringAnnualIncrease? item.enteringAnnualIncrease: '-'}}</div>
              </ion-col>
              <ion-col size-sm="12" size-md="6" size-lg="4" size-xs="12" class="mt-10">
                <div class="formLabelRegularfs14">
                  Remarks
                  <span class="red-cl">&nbsp;*</span>
                </div>
                <div class="formLabelBoldfs14">{{item.enteringremarksasrequired? item.enteringremarksasrequired: '-'}}</div>
              </ion-col>
            </ion-row>
          </div>
        </div>
        <div class="clear50"></div>
      </div>
    </div>
  </div>
</ion-content>
